import { inject, Injectable } from '@angular/core';
import { IVehicle, UUID } from '@okcargo-apps/shared-domain';
import {
  CreateVehicleAsCarrierCommand,
  CreateVehicleAsCarrierCommandHandler,
  DeleteVehicleByCarrierCommand,
  DeleteVehicleByCarrierCommandHandler,
  UpdateVehicleAsCarrierCommand,
  UpdateVehicleAsCarrierCommandHandler,
} from '@okcargo/command-processor';
import { BaseCommandRepository } from '../command-repository/command.repository';
import { transformFromIVehicleToCreateCommand, transformFromIVehicleToUpdateCommand } from './vehicle.mapper';

@Injectable({
  providedIn: 'root',
})
export class VehicleCommandService {
  private readonly createVehicleAsCarrierCommandHandler: CreateVehicleAsCarrierCommandHandler;
  private readonly updateVehicleAsCarrierCommandHandler: UpdateVehicleAsCarrierCommandHandler;
  private readonly deleteVehicleByCarrierCommandHandler: DeleteVehicleByCarrierCommandHandler;

  constructor() {
    const commandRepository = inject(BaseCommandRepository);

    this.createVehicleAsCarrierCommandHandler = new CreateVehicleAsCarrierCommandHandler(commandRepository);
    this.updateVehicleAsCarrierCommandHandler = new UpdateVehicleAsCarrierCommandHandler(commandRepository);
    this.deleteVehicleByCarrierCommandHandler = new DeleteVehicleByCarrierCommandHandler(commandRepository);
  }

  public createVehicle(vehicle: IVehicle): Promise<void> {
    const command: CreateVehicleAsCarrierCommand = transformFromIVehicleToCreateCommand(vehicle);
    return this.createVehicleAsCarrierCommandHandler.handle(command);
  }

  public updateVehicle(vehicle: IVehicle): Promise<void> {
    const command: UpdateVehicleAsCarrierCommand = transformFromIVehicleToUpdateCommand(vehicle);
    return this.updateVehicleAsCarrierCommandHandler.handle(command);
  }

  /** `DeleteVehicleByCarrierCommand` is a soft delete. */
  public softDeleteVehicle(id: UUID): Promise<void> {
    const command: DeleteVehicleByCarrierCommand = { id };
    return this.deleteVehicleByCarrierCommandHandler.handle(command);
  }
}
